/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React from 'react';
import { StyleSheet, View, TouchableOpacity, TextInput } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';

import Colors from '@global/colors';
import { translate } from '@global/translate';
import { useTranslationDisabled } from '@components/shared/TranslationContext';

import PropTypes from 'prop-types';

const propTypes = {
  valueText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  buttonLabel: PropTypes.string,
  icon: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styleInput: PropTypes.object,
  styleButton: PropTypes.object,
  withBorder: PropTypes.bool,
};

const defaultProps = {
  valueText: '',
  placeholder: '',
  buttonLabel: '',
  icon: '',
  width: 300,
  styleInput: {},
  styleButton: {},
  withBorder: false,
};

function InputGroup(props) {
  const {
    testID,
    valueText = '',
    placeholder = '',
    buttonLabel = '',
    icon = '',
    width = 300,
    styleInput = {},
    styleButton = {},
    withBorder = false,
    onPress = () => {},
    onChange = () => {},
  } = props;
  const translationDisabled = useTranslationDisabled();

  return (
    <View testID={testID} style={[styles.search, { width }]}>
      <TextInput
        label=""
        value={valueText || valueText == 0 ? valueText.toString() : ''}
        placeholder={translationDisabled ? placeholder : translate(placeholder)}
        style={[
          styles.searchInput,
          withBorder ? { borderColor: Colors.grey0 } : {},
          styleInput,
        ]}
        onChangeText={(value) => onChange(value)}
        onSubmitEditing={() => onPress()}
      />
      <TouchableOpacity
        activeOpacity={0.6}
        style={[styles.searchBtn, styleButton]}
        onPress={() => onPress()}>
        <SociollaText
          type="medium"
          style={[styles.searchBtnText, { marginRight: icon ? 10 : 0 }]}>
          {buttonLabel}
        </SociollaText>
        {icon ? (
          <Image
            style={{ width: 12, height: 12 }}
            width={12}
            height={12}
            svg={true}
            source={icon}
          />
        ) : (
          false
        )}
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  search: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchInput: {
    width: '100%',
    height: 36,
    fontSize: 12,
    fontFamily: 'figtree-regular',
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: Colors.white,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    borderWidth: 1,
    borderColor: Colors.white,
  },
  searchBtn: {
    height: 36,
    borderRadius: 10,
    backgroundColor: Colors.blue3,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
  },
  searchBtnText: {
    fontSize: 14,
    color: Colors.white,
  },
});

InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;

export default React.memo(InputGroup, (prev, next) => prev == next);
